var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "card service-card mb-3" }, [
    _c(
      "div",
      {
        staticClass: "card-body service-card__body",
        class: { "d-flex flex-column justify-content-center": _vm.fixed }
      },
      [
        !_vm.fixed
          ? _c(
              "div",
              { staticClass: "service-card__image" },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("p", {
          staticClass: "service-card__title",
          class: { "service-card__title--fixed": _vm.fixed },
          domProps: { innerHTML: _vm._s(_vm.displayTitle) }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "service-card__details",
            class: { "service-card__details--active": _vm.open || _vm.fixed }
          },
          [
            _vm.details
              ? _c(
                  "ul",
                  { staticClass: "service-card__list" },
                  _vm._l(_vm.details, function(detail) {
                    return _c("li", { key: detail }, [
                      _vm._v("\n          " + _vm._s(detail) + "\n        ")
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("body"),
            _vm._v(" "),
            _vm.fixed
              ? _c("div", [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-outline-more-info text-primary mb-0",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#getService"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setFormService(
                            "I need a service not listed here"
                          )
                        }
                      }
                    },
                    [_vm._v("Send Us a Message")]
                  )
                ])
              : _c("div", { staticClass: "service-card__contact" }, [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.needThisText))
                  ]),
                  _vm._v(" "),
                  _vm.buttonUrl
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-primary service-card__button",
                          attrs: { target: "_blank", href: _vm.buttonUrl }
                        },
                        [_vm._v(_vm._s(_vm.buttonText))]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-primary service-card__button",
                          attrs: {
                            "data-toggle": "modal",
                            "data-target": "#getService"
                          },
                          on: {
                            click: function($event) {
                              return _vm.setFormService(_vm.title)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonText))]
                      )
                ])
          ],
          2
        ),
        _vm._v(" "),
        !_vm.fixed
          ? _c(
              "button",
              {
                staticClass: "service-card__toggle",
                on: {
                  click: function($event) {
                    return _vm.toggleOpen()
                  }
                }
              },
              [
                _vm.open
                  ? _c("span", [
                      _vm._v("\n        Hide Details "),
                      _c("span", { staticClass: "fa fa-chevron-up" })
                    ])
                  : _c("span", [
                      _vm._v("\n        Show Details "),
                      _c("span", { staticClass: "fa fa-chevron-down" })
                    ])
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf5ecbca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf5ecbca","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/service-card.vue
// module id = 197
// module chunks = 15 65